<template>
  <span>
    <!-- grid search -->
    <v-row>
      <v-col :cols="disabled?12:6">
        <v-text-field
          v-model="keyword"
          append-icon="mdi-magnify"
          label="Cari"
          hide-details
          single-line
          clearable
        ></v-text-field>
      </v-col>
      <!-- form rincian transaksi -->
      <v-col cols="6" class="text-right" v-if="!disabled">
        <v-btn
          class="ml-2 mt-2"
          color="primary"
          outlined
          @click="populateItems"
          :loading="populating"
        >
          <span class="hidden-xs-only">Ambil Data</span>
          <v-icon :right="!$vuetify.breakpoint.xsOnly">mdi-sync</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <br />
    <v-row>
      <v-col cols="12" class="px-0 py-0">
        <v-divider />
        <v-data-table
          :headers="headers"
          :items="items"
          :loading="loading"
          :loading-text="app.grid.loading"
          :no-data-text="app.grid.noData"
          :search="keyword"
          multi-sort
          hide-default-footer
        >
          <!-- custom field render -->
          <template v-slot:item.Nominal="{ item }">
            <v-chip :color="item.Jenis == 'belanja'?'primary':'success'" small outlined>
              <v-icon small left>{{item.Jenis == 'belanja'?'mdi-cart':'mdi-wallet'}}</v-icon>
              {{item.Total | currency}}
            </v-chip>
          </template>

          <!-- custom updated date & by -->
          <template v-slot:item.LastUpdatedDate="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <span dark v-on="on">{{$format.relativeUpdatedDate(item)}}</span>
              </template>
              <span>{{$format.updatedDate(item)}}</span>
            </v-tooltip>
          </template>

          <!-- grid actions -->
          <!-- <template v-slot:item.Actions="{ item }" v-if="!disabled">
            <v-btn class="mr-4" icon color="blue" @click="editItem(item)">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on" :loading="item.processing">
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list dense>
                <v-list-item @click="deleteItem(item)">
                  <v-list-item-icon>
                    <v-icon color="red">mdi-delete</v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title>Hapus</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>-->

          <!-- content edit -->
        </v-data-table>
      </v-col>
    </v-row>
  </span>
</template>

<style lang="scss">
</style>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import { cloneDeep } from "lodash";

export default {
  name: "rincian-sp2b",
  props: {
    value: Array,
    loading: Boolean,
    disabled: Boolean,
    IDSekolah: String,
    Tanggal: String,
    IDKegiatan: String
  },
  data: () => ({
    populating: false,
    rekening: {
      keyword: "",
      awaiting: false
    },
    keyword: "",
    item: {},
    itemsClean: [],
    items: [],
    headers: [
      {
        value: "Rekening.Kode",
        text: "Kode",
        width: "20%"
      },
      {
        value: "Rekening.Nama",
        text: "Rekening",
        width: "50%"
      },
      {
        value: "Nominal",
        text: "Nominal",
        width: "30%"
      }
      // {
      //   value: "LastUpdatedDate",
      //   text: "Terakhir Diubah",
      //   width: "15%"
      // },
      // {
      //   value: "Actions",
      //   sortable: false,
      //   width: "15%"
      // }
    ]
  }),
  computed: {
    ...mapState({
      app: state => state.app,
      list: state => state.list
    }),
    ...mapGetters("list", [
      "isRekeningLoading",
      "listRekeningBelanja",
      "listRekeningPenerimaan"
    ]),
    listRekening() {
      if (this.item.Jenis == "belanja") return this.listRekeningBelanja;
      return this.listRekeningPenerimaan;
    }
  },
  methods: {
    ...mapActions("list", ["refreshRekening"]),
    populateItems() {
      this.populating = true;
      this.$axios
        .post("report/transaksi/sp2b", {
          IDSekolah: this.IDSekolah,
          IDKegiatan: this.IDKegiatan,
          Bulan: new Date(this.Tanggal)
        })
        .then(res => {
          let items = cloneDeep(this.itemsClean);
          let data = res.data.Data || [];
          if (items.length > 0) {
            if (data.length > 0) {
              let dataMap = {};
              data.forEach(d => {
                dataMap[d.IDRekening] = d;
              });

              let mergedRekening = [];
              items.forEach(d => {
                let newData = dataMap[d.IDRekening];
                if (newData) {
                  mergedRekening.push(d.IDRekening);
                  d.Total += newData.Total || 0;

                  if (!d.ListIDTransaksi) d.ListIDTransaksi = [];
                  if (!d.ListIDTransaksiDetail) d.ListIDTransaksiDetail = [];

                  newData.ListIDTransaksi.forEach(id => {
                    d.ListIDTransaksi.push(id);
                  });

                  newData.ListIDTransaksiDetail.forEach(id => {
                    d.ListIDTransaksiDetail.push(id);
                  });
                }
              });

              // push to new item
              for (let idRekening in dataMap) {
                if (mergedRekening.indexOf(idRekening) == -1) {
                  items.push(dataMap[idRekening]);
                }
              }
            }
          } else {
            items = data;
          }

          this.$emit("update-details", items);
          this.items = items;

          this.$dialog.notify.success("pengambilan data berhasil", {
            ...this.app.notification
          });
        })
        .catch(error => {
          this.$dialog.notify.error(error, {
            ...this.app.notification
          });
        })
        .finally(() => {
          this.populating = false;
        });
    },
    preProcessItem(item) {
      item.Nominal = parseFloat(item.Nominal);
      return item;
    },
    filterRekening(item, queryText) {
      const nama = item.Nama.toLowerCase();
      const kode = item.Kode.toLowerCase();
      const searchText = queryText.toLowerCase();

      return nama.indexOf(searchText) > -1 || kode.indexOf(searchText) > -1;
    },
    changeJenisTransaksi() {
      this.item.Rekening = {};
    }
  },
  mounted() {
    this.items = this.value;
    this.itemsClean = this.value;
  },
  watch: {
    "item.Rekening"(v) {
      if (!this.$util.isEmpty(v)) this.item.IDRekening = v.IDRekening;
      else this.item.IDRekening = "";
    },
    value(v) {
      this.items = v;
    }
  }
};
</script>

